import { render, staticRenderFns } from "./ReadAloudDetail.vue?vue&type=template&id=4151ed14&scoped=true&"
import script from "./ReadAloudDetail.vue?vue&type=script&lang=js&"
export * from "./ReadAloudDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudDetail.vue?vue&type=style&index=0&id=4151ed14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151ed14",
  null
  
)

export default component.exports